import { Component, inject, OnInit } from '@angular/core';
import { NZ_DRAWER_DATA, NzDrawerRef } from 'ng-zorro-antd/drawer';
import { Partner, Document, DocumentType } from '@app/shared';
import { TableColumn } from '@app/shared';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { DocumentService } from '@app/core';
import { GetParams } from '@app/shared';

@Component({
  selector: 'app-partner-details-drawer',
  standalone: false,
  templateUrl: './maestros-details-drawer.component.html',
  styleUrl: './maestros-details-drawer.component.less'
})
export class MaestrosDetailsDrawerComponent implements OnInit {
  nzData: {
    columnsData: TableColumn[];
    element: any; // Using 'any' to handle possible differences in the Partner model
    maestroName: string;
  } = inject(NZ_DRAWER_DATA);

  columnsData: TableColumn[] = [];
  constructor(
    private drawerRef: NzDrawerRef<string>,
    private documentService: DocumentService
  ) {}

  ngOnInit(): void {
    this.columnsData = this.nzData.columnsData;
  }

  close(): void {
    this.drawerRef.close();
  }

  // Helper method to find option name by ID
  findOptionNameById(id: number | null, list: any[]): string {
    if (id === null || id === undefined) return '-';
    return list.find(item => item.id === id)?.name || '-';
  }

  // Helper method to check if a value is empty
  isEmpty(value: any): boolean {
    return value === null || value === undefined || value === '';
  }

  // Helper method to get the appropriate icon for a document based on its extension
  getDocumentIcon(extension: string): string {
    const ext = extension?.toLowerCase();

    switch (ext) {
      case 'pdf':
        return 'pdf';
      case 'doc':
      case 'docx':
        return 'document';
      case 'xls':
      case 'xlsx':
        return 'spreadsheet';
      case 'ppt':
      case 'pptx':
        return 'presentation';
      case 'jpg':
      case 'jpeg':
      case 'png':
      case 'gif':
        return 'image';
      default:
        return 'file';
    }
  }

  // Format file size to human-readable format
  formatFileSize(size: string | number): string {
    if (!size) return '0 KB';

    let numSize: number;
    if (typeof size === 'string') {
      numSize = parseInt(size, 10);
      if (isNaN(numSize)) return '0 KB';
    } else {
      numSize = size;
    }

    if (numSize < 1024) {
      return numSize + ' B';
    } else if (numSize < 1024 * 1024) {
      return Math.round(numSize / 1024) + ' KB';
    } else {
      return Math.round(numSize / (1024 * 1024) * 10) / 10 + ' MB';
    }
  }

  // Helper method to get filtered options from columnsData
  getOptionList(fieldName: string): any[] {
    const column = this.columnsData.find(c => c.pathData?.name === fieldName);
    return column?.optionList || [];
  }
}
